export const STORE_DEPOSIT_OPTION_LABELS = {
  pageTitle: "Opção de Depósito",
  pageDescription: "Defina como a loja realiza o depósito",
  storeLabel: "Loja",
  storePlaceholder: "Selecione a loja",
  saveButton: "Salvar",
  saving: "Salvando…",
  selectStoreHint: "Selecione a loja para ver as opções de depósito",
  emptyOptions: "Esta loja não tem opções de depósito cadastradas",
  saveSuccess: "Opções de depósito atualizadas",
} as const;

export interface FilterOption {
  readonly value: string;
  readonly label: string;
}

export type DepositOptionDraft = Readonly<Record<number, boolean>>;

export const GLOBALLY_HANDLED_STATUS: ReadonlySet<number> = new Set([
  401, 403, 423,
]);

export const STORE_DEPOSIT_OPTION_MESSAGES = {
  SAVE_SUCCESS: {
    description: STORE_DEPOSIT_OPTION_LABELS.saveSuccess,
  },
  SAVE_ERROR: {
    description: "Não foi possível salvar as opções de depósito",
    variant: "destructive" as const,
  },
};

export const SKELETON_ROW_COUNT = 3;

export const OPERATION_CODE_PREFIX = "#";
